import axios from '@/http/axios';

export default {
  fetch: (config: any = {}) => {
    return axios.get(`/questionnaire-answers`, config);
  },
  fetchQuestion: (oid, config: any = {}) => {
    return axios.get(`/questionnaire-answers/${oid}/questions/next`, config);
  },
  updateAnswer: (oid, config: any = {}) => {
    return axios.put(`/questionnaire-answers/${oid}/question-answers`, config);
  },
  complete: (oid, config: any = {}) => {
    return axios.put(`/questionnaire-answers/${oid}/complete`, config);
  },
  fetchResult: (oid, config: any = {}) => {
    return axios.get(`/questionnaire-answers/${oid}/result`, config);
  },
  fetchResultForReview: (oid, config: any = {}) => {
    return axios.get(`/questionnaire-answers/${oid}/review`, config);
  },
  fetchResultForPreview: (oid, config: any = {}) => {
    return axios.get(`/questionnaire-answers/${oid}/preview`, config);
  },
  fetchPrevQuestion: (oid, config: any = {}) => {
    return axios.get(
      `/questionnaire-answers/${oid}/questions/previous`,
      config
    );
  },
  startOver: (oid) => {
    return axios.delete(`/questionnaire-answers/${oid}/start-over`);
  },
  confirmCandidateProfile: (config: any = {}) => {
    return axios.get(
      `/questionnaire-answers/confirm-candidate-profile`,
      config
    );
  },
  submitGuardianInfo: (oid, config: any = {}) => {
    return axios.put(
      `/questionnaire-answers/${oid}/update-guardian-info`,
      config
    );
  },
  downloadReport: (oid) => {
    return axios.get(`/questionnaire-answers/${oid}/download-report`, {
      responseType: 'arraybuffer',
    });
  },
  attachReport: (oid, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`/questionnaire-answers/${oid}/attach-report`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  downloadAttachedReport: (oid) => {
    return axios.get(`/questionnaire-answers/${oid}/download-attached-report`, {
      responseType: 'arraybuffer',
    });
  },
  fetchHCS: (oid, config: any = {}) => {
    return axios.get(`/questionnaire-answers/${oid}/hcs`, config);
  },
  downloadHCSReport: (oid) => {
    return axios.get(`/questionnaire-answers/${oid}/download-hcs`, {
      responseType: 'arraybuffer',
    });
  },
};
